import PropTypes from 'prop-types';
import { memo } from 'react';
// @mui
import { Stack } from '@mui/material';
//
import { NavListRoot } from './NavList';
import useAuth from 'src/hooks/useAuth';
import { FilterNavItemsFunction2 } from '..';

// ----------------------------------------------------------------------

const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',

  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

NavSectionHorizontal.propTypes = {
  navConfig: PropTypes.array,
};

function NavSectionHorizontal({ navConfig }) {
  const { user } = useAuth();

  const filteredSideMenu = FilterNavItemsFunction2(navConfig, user);

  return (
    <Stack
      direction="row"
      justifyContent="center"
      sx={{ bgcolor: 'background.neutral', borderRadius: 1, px: 0.5 }}
    >
      <Stack direction="row" sx={{ ...hideScrollbar, py: 1 }}>
        {filteredSideMenu.map((group) => (
          <Stack key={group.subheader} direction="row" flexShrink={0}>
            {group.children.length > 0 &&
              group.children.map((list) => (
                <NavListRoot key={list.title + list.path} list={list} />
              ))}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}

export default memo(NavSectionHorizontal);
